import CONSTANTS from "components/FallRegistration/utils/constants";
export default {
	title: "Your personalized, practicable leadership journey",
	sections: [
		{
			title: "WAYS TO START",
			icon: "check",
			items: [
				{ text: "Take the leadership self-assessment", link: "/assessment" },
				{ text: "Take the Technical Skills Assessment", link: "/assessment/technical-skills" },
				{ text: "Schedule a free advising session", link: "/schedule-advising-session" },
				// { //This will be in a second release, NEed to gather member testimonials
				// 	text: "Hear from AAPL Members",
				// 	icon: "play",
				// 	iconClass: "d-none d-lg-inline-block",
				// 	link: "/community",
				// },
			],
		},

		{
			title: "LIFELONG LEARNING ",
			icon: "education",
			items: [
				{
					text: "The AAPL Experience",
					link: "/education/experience",
				},
				{ text: "Leadership Basics & Early Career", link: "/education/early-career" },
				{ text: "Advanced & C-Level", link: "/education/c-level" },
				{ text: "CEO Academy", link: "/ceo-academy" },
				{ text: "CMO Academy", link: "/cmo-academy" },
				{ text: "Inter-Professional Leadership Academy", link: "/inter-professional-leadership-academy" },
				{ text: "Find CME Courses", link: "/education/courses" },
				{ text: "Events & Webinars", link: "/events" },
				{ text: "AAPL Solutions for Teams & Organizations", link: "/aapl-solutions" },
			],
		},

		{
			title: "CREDENTIALS",
			icon: "star",
			items: [
				{
					text: "Reaching CPE Status",
					subText: "The industry's mark of an exceptional leader",
					link: "/credentials/cpe",
				},
				{
					text: "Master's Programs",
					subText: "Credit sharing with top business schools",
					link: "/credentials/masters",
				},
				{
					text: "Fellowship (FAAPL)",
					subText: "The highest level of Leadership Excellence & Commitment",
					link: "/credentials/fellowship",
				},
			],
		},

		{
			title: "CAREER SUPPORT",
			icon: "location",
			items: [
				{
					text: "Coaching & Mentoring",
					link: "/membership/mentoring",
				},
				{ text: "Career Services", link: "/career-services" },
				{ text: "Job Board", link: "https://jobsearch.physicianleaders.org/" },
				{ text: "Free Wellness & Burnout Resources", link: "/careers/wellness" },
				{
					text: "Contract Review & Negotiation",
					link: "https://go.resolve.com/aapl?utm_campaign=American%20Association%20for%20Physician%20Leadership&utm_source=website&utm_medium=partner-page",
				},
			],
		},
	],

	side: {
		title: "UPCOMING EVENTS",
		data: [
			{
				subTitle: `${CONSTANTS.FALL_YEAR} AAPL Fall Institute`,
				dateLocation: `${CONSTANTS.FALL_DATES}, ${CONSTANTS.FALL_YEAR} in Scottsdale, Arizona`,
				link: "/fall-institute",
			},
			{
				subTitle: "2026 Annual Leadership Conference",
				dateLocation: "October, 22-25 2026 in Scottsdale, Arizona",
				link: "/conference",
			},
		],
	},
};
